import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a78cbbd8295d50014cfcecb_1788767995047_d1e2c5cb/aven/src/app/sign-up-login-screen/components/AuthPage.tsx");
